<div class="headline" routerLink="/">
  <span>{{ 'shared.header.title' | translate }}</span>
</div>
<div class="user" (click)="openAccountModal()"
     *ngIf="(currentUser$ | async) as currentUser"
>
  <span class="name">
    {{
    currentUser.firstName && currentUser.lastName ?
      currentUser.firstName + ' ' + currentUser.lastName :
      ('shared.header.no-username' | translate)
    }}
  </span>
  <span class="username">
    ({{ currentUser.userName }})
  </span>
  <span>
    <i class="fas fa-user-cog"></i>
  </span>
</div>
